module.exports = __webpack_public_path__ + "static/hubspot-b822eb1e55f1cb48d181c9f3814b0fce.svg";